export class ChangePassword {
  UserId: Number;
  UserName: string;
  OldPassword: string;
  NewPassword: string;
  ConfirmPassword: string;
  AggregatorID: Number;

}
